export const GET_REPORT_GRAPH_REQUEST = 'GET_REPORT_GRAPH_REQUEST';
export const GET_REPORT_GRAPH_SUCCESS = 'GET_REPORT_GRAPH_SUCCESS';
export const GET_REPORT_GRAPH_FAIL = 'GET_REPORT_GRAPH_FAIL';

export const GET_CANCER_TYPE_REQUEST = 'GET_CANCER_TYPE_REQUEST';
export const GET_CANCER_TYPE_SUCCESS = 'GET_CANCER_TYPE_SUCCESS';
export const GET_CANCER_TYPE_FAIL = 'GET_CANCER_TYPE_FAIL';

export const ReportGraphAction = (data) => {
  return { type: GET_REPORT_GRAPH_REQUEST, payload: data };
};

export const GetCancerTypesAction = (data) => {
  return { type: GET_CANCER_TYPE_REQUEST };
};
